import React, { useState } from 'react';

import cx from 'classnames';

import { HIDE_TEXT, SHOW_TEXT } from '@/constants';

import styles from './Accordion.module.scss';

const Accordion = ({ title, content, canOpen = true }) => {
	const [accordionOpen, setAccordionOpen] = useState(true);
	return (
		<div className={styles.refundsContainer}>
			<div
				className={cx(
					styles.headerTab,
					accordionOpen ? null : styles.headerTabRemoveShadow,
				)}
			>
				{title}
				{canOpen ? (
					<div
						className={styles.showHideButton}
						onClick={() => {
							setAccordionOpen(!accordionOpen);
						}}
					>
						{accordionOpen ? HIDE_TEXT : SHOW_TEXT}
					</div>
				) : null}
			</div>

			<div>{accordionOpen ? <>{content}</> : null}</div>
		</div>
	);
};

export default Accordion;
